import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from '../customer/customer';
import { CustomerService } from '../customer/customer.service';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.css']
})
export class CustomerDetailComponent implements OnInit {
  customer: Customer;
  msgs: Message[];
  private isEdit: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
    private customerService: CustomerService) {
    this.customer = new Customer();
    this.msgs = [];
    this.isEdit = false;
  }

  ngOnInit() {
    // Here we go, we need to check if there was an id passed. if so, we 
    // have to query customer details to enable edit of customer.
    if (this.route.snapshot.params['id'] != null) {
      this.customerService.qryCustomer(+this.route.snapshot.params['id']).subscribe(
        (customer: Customer) => {
          if (customer != null) {
            this.customer = customer;
            this.isEdit = true;
          } else {
            this.msgs.push({ severity: 'warn', summary: 'Failed to load customer.' });
          }
        },
        (err) => {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Failed to load customer.' })
        }
      );
    }
  }


  /**
   * Saves customer.
   */
  public onSubmit() {
    if (!this.isEdit) {
      this.customerService.save(this.customer).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Lieferant wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/customer');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Lieferant konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save customer, error msg: ' + err);
        }
      );
    }else{
      this.customerService.update(this.customer).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Lieferant wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/customer');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Lieferant konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save customer, error msg: ' + err);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/customer-detail/customer-detail.component.ts